import { render, staticRenderFns } from "./iuran.vue?vue&type=template&id=55cf30ab&scoped=true&"
import script from "./iuran.vue?vue&type=script&lang=js&"
export * from "./iuran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf30ab",
  null
  
)

export default component.exports